export enum ClientType {
    MOBILE = 'mobile',
    WEB = 'web',
}
